import React, { useState, useEffect } from "react";
import AuthService from "services/auth.service";
import plusCircle from "../assets/img/add-circle.png";
import phone from "../assets/img/Vector.png";
import sms from "../assets/img/sms.svg";

// reactstrap components
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";

function Support() {
  const currentUser = AuthService.getCurrentUser();
  const id = currentUser.id;
  const [transaction, setTransaction] = useState([]);
  const [switches, setSwitches] = useState({
    switch1: false,
    switch2: false,
    switch3: false,
  });
  // State to keep track of open/close status of each FAQ item
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSwitch = (switchName) => {
    setSwitches((prevSwitches) => ({
      ...prevSwitches,
      [switchName]: !prevSwitches[switchName],
    }));
  };

  // Toggle function to show or hide answer on click
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    retrieveNotififcation();
  }, []);

  const retrieveNotififcation = () => {
    AuthService.fetchNotification(id)
      .then((response) => {
        setTransaction(response.data);
        //console.log(response.data);
      })
      .catch((e) => {
        //console.log(e);
      });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "short" }; // Using 'short' to get abbreviated month names
    return date.toLocaleDateString("en-US", options);
  };

  // FAQ data as an array of objects
const faqData = [
  {
    question: "What types of massage do you offer?",
    answer: "We offer Swedish, Deep Tissue, Sports, Prenatal, Hot Stone, and Therapeutic Massage, all tailored to your specific needs."
  },
  {
    question: "How do I book an appointment?",
    answer: "You can book online through our website, call us directly, or visit our location in person."
  },
  {
    question: "What should I expect during my first visit?",
    answer: "Your therapist will review your health history, discuss your goals, and customize your session for maximum comfort and effectiveness."
  },
  {
    question: "Do you accept insurance or HSA/FSA payments?",
    answer: "Yes, we accept HSA/FSA payments and can provide receipts for insurance reimbursement if applicable."
  },
  {
    question: "What is your cancellation policy?",
    answer: "We require 24-hour notice for cancellations to avoid a fee. Late cancellations may incur a 50% charge."
  },
  {
    question: "How often should I get a massage?",
    answer: "For general wellness, every 4–6 weeks is ideal. For pain relief or injury recovery, weekly or biweekly sessions may be recommended."
  }
];

  return (
    <>
      <div className="content jag-web">
        <div className="auto-adjust">
          <Col lg="8" md="8" sm="6" className="house-all house-all-arrange">
         
            <div className="typography-line-dash  line-dash-mob welcome-msg ">
              <h2>Contact Us</h2>
            </div>
            <div className="support-contact gap-soace">
              <img src={phone} alt="phone-icon " />
              
              <p ><a style={{color: "#220240"}} href="tel:+12286964218">(228) 696-4218 </a></p>
            </div>
            <div className="support-contact gap-soace2">
              <img src={sms} alt="phone-icon " />
              <p><a href="mailto:internationalmassagecouncil@gmail.com" aria-label="Email us at internationalmassagecouncil@gmail.com" style={{color: "#220240"}}>internationalmassagecouncil@gmail.com</a></p>
            </div>
          </Col>

          <Col lg="8" md="8" sm="6" className="house-all  house-all-arrange-mob">
            <div className="typography-line-dash  line-dash-mob welcome-msg ">
              <h2>FAQs</h2>
            </div>

            <div className="faq-container">
              {/* Render FAQs in rows of 2 */}
              {faqData.map(
                (faq, index) =>
                  index % 2 === 0 && ( // Start a new Row for every two FAQs
                    <Row key={index} className="mb-4 mb-gapp">
                      <Col md="6">
                        <div
                          className={`faq-item ${
                            openIndex === index ? "active" : ""
                          }`}
                          onClick={() => toggleFAQ(index)}
                        >
                          <h3>{faq.question}</h3>{" "}
                          
                          {openIndex === index && (
                            <div className="faq-answer">
                              <p>{faq.answer}</p>
                            </div>
                          )}
                        </div>
                      </Col>
                      {faqData[index + 1] && ( // Check if the next item exists
                        <Col md="6">
                          <div
                            className={`faq-item ${
                              openIndex === index + 1 ? "active" : ""
                            }`}
                            onClick={() => toggleFAQ(index + 1)}
                          >
                            <h3>{faqData[index + 1].question}</h3>
                            {openIndex === index + 1 && (
                              <div className="faq-answer">
                                <p>{faqData[index + 1].answer}</p>
                              </div>
                            )}
                          </div>
                        </Col>
                      )}
                    </Row>
                  )
              )}
            </div>
          </Col>
        </div>
      </div>
      <div className="content noti-web ">
        <Row>
          <Col md="5">
            <Card className="outer-line noti-card">
              <CardTitle tag="h5">Notifications</CardTitle>
              <CardBody className="jag-tran-card" style={{ color: "white" }}>
                {transaction.map((transaction) => (
                  <div key={transaction.id} className="jag-transaction-item">
                    <div className="jag-transaction-info">
                      <div>
                        <div
                          className="jag-transaction-type"
                          style={{ textTransform: "uppercase" }}
                        >
                          {transaction.title}
                        </div>

                        <div className="jag-transaction-type noti-mess">
                          {transaction.message}
                        </div>
                      </div>
                    </div>
                    <div className="jag-transaction-details">
                      <div
                        className="jag-transaction-time"
                        style={{ paddingLeft: "1px" }}
                      >
                        {formatDate(transaction.createdAt)}
                      </div>
                    </div>
                  </div>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
      
    </>
  );
}

export default Support;
